/**
 * Iranian rial.
 */
export var IRR = {
  code: 'IRR',
  base: 10,
  exponent: 2
};